"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var Email = /** @class */ (function (_super) {
    __extends(Email, _super);
    function Email(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: form_store_1.default.getState().data.email,
            error: form_store_1.default.getState().error.email
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            if (_this._isMounted) {
                _this.setState({
                    value: form_store_1.default.getState().data.email,
                    error: form_store_1.default.getState().error.email,
                });
            }
        });
        return _this;
    }
    Email.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    Email.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    Email.prototype.render = function () {
        var _a = this.state, value = _a.value, error = _a.error, errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("input", { className: "input-text", type: "email", name: "email", defaultValue: this.state.value, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
            react_1.default.createElement("p", { className: "form__note" },
                "\u30D5\u30A9\u30FC\u30E0\u9001\u4FE1\u5F8C\u3001\u5165\u529B\u3044\u305F\u3060\u3044\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5B9B\u306B\u53D7\u4ED8\u78BA\u8A8D\u30E1\u30FC\u30EB\u304C\u81EA\u52D5\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002\u30E1\u30FC\u30EB\u304C\u53D7\u4FE1\u3067\u304D\u306A\u3044\u5834\u5408\u306F",
                react_1.default.createElement("a", { className: "js-modal-trigger", "data-target": "#modal-support" }, "\u3053\u3061\u3089"),
                "\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002")));
    };
    return Email;
}(react_1.Component));
exports.default = Email;
